import { queryOptions } from "@tanstack/react-query";
import { getHttp } from "../api-client";
import { API_ENDPOINTS } from "../endpoints";
import { queryKeys } from "../queryKeys";
import type { PrivacyPolicySyncState } from "../types/auth";

export const privacyPolicyQueries = {
  sync: (userId: string | undefined) =>
    queryOptions({
      queryKey: queryKeys.privacyPolicySync(userId),
      queryFn: () => getHttp().get<PrivacyPolicySyncState>(API_ENDPOINTS.PRIVACY_POLICY.ME),
    }),
};
